// (3101): set by WholesalerPaymentBanner's real height, so the space
// reserved for it (content offset, sidebar spacing) stays correct.
export const WHOLESALER_BANNER_HEIGHT_VAR = '--wholesaler-banner-height';

// Always set background colour at darkMode because of dark Navbar
const alertBg = '#E53E3E';

export const alertStyles = {
    // Override the bg prop from Alert component
    bg: alertBg,
    borderRadius: 'none',
    '& div[class^="chakra-alert"]': {
        textColor: 'white',
    },
    '& a.chakra-link:hover': {
        textDecoration: 'none',
    },
};
